import { useRef } from "react";
import { useT } from "../../../i18n/LanguageContext";
// Replace this asset with your real Sellaris screenshot.
// Recommended: PNG, JPG or WebP, aspect ratio 9:19 (e.g. 390x844 or 1170x2532),
// no phone bezel — just the app content.
//   1. Drop your screenshot in src/assets/img/sellaris/ (e.g. app-screen.png).
//   2. Update the import line below to match the file name/extension.
import appScreen from "../../../assets/img/sellaris/sellaris.png";

// The phone tilts in 3D toward the pointer, with a glare that tracks it.
export function SellarisMockup() {
	const { t } = useT();
	const stageRef = useRef(null);

	const onMove = (e) => {
		if (e.pointerType !== "mouse") return;
		const el = stageRef.current;
		const r = el.getBoundingClientRect();
		const px = (e.clientX - r.left) / r.width - 0.5;
		const py = (e.clientY - r.top) / r.height - 0.5;
		el.style.setProperty("--ry", `${px * 22}deg`);
		el.style.setProperty("--rx", `${-py * 16}deg`);
		el.style.setProperty("--gx", `${(px + 0.5) * 100}%`);
		el.style.setProperty("--gy", `${(py + 0.5) * 100}%`);
	};

	const onLeave = () => {
		const el = stageRef.current;
		el.style.setProperty("--ry", "-14deg");
		el.style.setProperty("--rx", "6deg");
	};

	return (
		<div className="sellarisStage" ref={stageRef} onPointerMove={onMove} onPointerLeave={onLeave}>
			<div className="sellarisStage_rings" aria-hidden="true">
				<span />
				<span />
				<span />
			</div>
			<div className="sellarisMockup">
				<div className="sellarisMockup_notch" aria-hidden="true" />
				<div className="sellarisMockup_screen">
					<img
						src={appScreen}
						alt={`${t("sellaris.title")} mobile app`}
						className="sellarisMockup_image"
						loading="lazy"
						draggable="false"
					/>
				</div>
				<div className="sellarisMockup_glare" aria-hidden="true" />
			</div>
		</div>
	);
}
